import mixitup from 'mixitup';
import mixitupMultifilter from '../mixitup-multifilter.min.js';

const Blog = {
	init: function() {
		mixitup.use(mixitupMultifilter, { multifilter: { enable: true } });
		mixitup('.blog-grid', {
			multifilter: { enable: true },
		});
	}
}

export default Blog;
